import type { FC } from 'react'
import React from 'react'

import { Scrollbar } from '@fourthwall/components'

import * as S from './TooltipBox.styled'
import type { Props } from './types'

export const TooltipBox: FC<Props> = ({ children, size }) => (
  <S.Container size={size}>
    <Scrollbar maxHeight={256}>{children}</Scrollbar>
  </S.Container>
)
